import { render } from "./Publish.vue?vue&type=template&id=45d8afc3&scoped=true&ts=true"
import script from "./Publish.vue?vue&type=script&lang=ts"
export * from "./Publish.vue?vue&type=script&lang=ts"

import "./Publish.vue?vue&type=style&index=0&id=45d8afc3&scoped=true&lang=scss"
import "./Publish.vue?vue&type=style&index=1&id=45d8afc3&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d8afc3"]])

export default __exports__